import { ColorPickerFunction } from './ColorPickerComponent';

const COLORS = [
    {
        label: 'Default',
        fill: undefined,
        stroke: undefined,
    },
    {
        label: 'Blue',
        fill: '#BBDEFB',
        stroke: '#0D4372',
    },
    {
        label: 'Orange',
        fill: '#FFE0B2',
        stroke: '#6B3C00',
    },
    {
        label: 'Green',
        fill: '#C8E6C9',
        stroke: '#205022',
    },
    {
        label: 'Red',
        fill: '#FFCDD2',
        stroke: '#831311',
    },
    {
        label: 'Purple',
        fill: '#E1BEE7',
        stroke: '#5B176D',
    },
    {
        label: 'Black',
        fill: '#969696',
        stroke: '#000000',
    },
    {
        label: 'White',
        fill: '#FFFFFF',
        stroke: '#000000',
    },
];

/**
 * @param {{ colors: any; }} config
 * @param {{ defaultFillColor: any; defaultStrokeColor: any; }} bpmnRendererConfig
 * @param {any} popupMenu
 * @param {any} modeling
 * @param {any} translate
 */
export function ColorPopupProvider(config, bpmnRendererConfig, popupMenu, modeling, translate) {
    this._popupMenu = popupMenu;
    this._modeling = modeling;
    this._translate = translate;

    this._colors = (config && config.colors) || COLORS;
    this._defaultFillColor = (bpmnRendererConfig && bpmnRendererConfig.defaultFillColor) || 'white';
    this._defaultStrokeColor = (bpmnRendererConfig && bpmnRendererConfig.defaultStrokeColor) || 'rgb(34, 36, 42)';

    this._popupMenu.registerProvider('color-picker', this);
}

ColorPopupProvider.$inject = ['config.colorPicker', 'config.bpmnRenderer', 'popupMenu', 'modeling', 'translate'];

ColorPopupProvider.prototype.getEntries = function (/** @type {any} */ elements) {
    const self = this;

    const colorIconHtml = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" height="100%" width="100%">
      <rect rx="2" x="1" y="1" width="22" height="22" fill="var(--fill-color)" stroke="var(--stroke-color)" style="stroke-width:2"></rect>
    </svg>
  `;

    const defaultColorIconHtml = `
    <svg xmlns="http://www.w3.org/2000/svg" height="85%" width="85%" viewBox="0 -2 70 70"  xml:space="preserve" transform="matrix(-1,0,0,1,0,0)">
    <g>
    <path fill="black" stroke="#000000" stroke-width="2" stroke-miterlimit="10" d="M11,41.265C11.052,53.27,20.401,63,32,63s21-9.73,21-21.735C53,25.729,32.035,1,32.035,1S10.931,25.729,11,41.265z"></path>
    </g>
    <g transform="translate(6,10) scale(2)">
    <path style="fill: white" d="M21.71,3.29a1,1,0,0,0-1.42,0l-18,18a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l18-18A1,1,0,0,0,21.71,3.29Z"></path>
    </g>
</svg>`;

    const colorPickerIconHtml = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" height="100%" width="100%">
      <defs>
        <linearGradient id="Gradient1">
          <stop class="stop1" offset="0%" />
          <stop class="stop2" offset="50%" />
          <stop class="stop3" offset="100%" />
        </linearGradient>
      </defs>
      <style>
        #rect1 {
          fill: url(#Gradient1);
        }
        .stop1 {
          stop-color: #83aee3;
        }
        .stop2 {
          stop-color: #85dc88;
        }
        .stop3 {
          stop-color: #de757c;
        }
      </style>
      <rect id="rect1" rx="2" x="1" y="1" width="22" height="22" stroke=${self._defaultStrokeColor} style="stroke-width:2"></rect>
    </svg>
  `;

    const entries = this._colors.map(function (/** @type {{ fill: any; stroke: any; label: string; }} */ color) {
        var entryColorIconHtml = colorIconHtml
            .replace('var(--fill-color)', color.fill || self._defaultFillColor)
            .replace('var(--stroke-color)', color.stroke || self._defaultStrokeColor);

        if (color.label === 'Default') {
            entryColorIconHtml = defaultColorIconHtml;
        }

        return {
            title: self._translate(color.label),
            id: color.label.toLowerCase() + '-color',
            imageHtml: entryColorIconHtml,
            action: createAction(self._modeling, elements, color),
        };
    });

    const colorPickerEntry = {
        title: 'Color Picker',
        id: 'color-picker-id',
        imageHtml: colorPickerIconHtml,
        action: () => createColorPickerAction(self._modeling, elements),
    };

    return entries.concat(colorPickerEntry);
    // return entries;
};

/**
 * @param {{ setColor: (arg0: any, arg1: any) => void; }} modeling
 * @param {any} element
 * @param {{ fill: any; stroke: any; label: string; }} color
 */
function createAction(modeling, element, color) {
    return function () {
        modeling.setColor(element, color);
    };
}

/**
 * @param {{ setColor: (arg0: any, arg1: any) => void; }} modeling
 * @param {any} element
 */
function createColorPickerAction(modeling, element) {
    /**
     * @param {string} color
     * @param {number} amount
     */
    function LightenDarkenColor(color, amount) {
        // #FFF not supportet rather use #FFFFFF
        const clamp = (/** @type {number} */ val) => Math.min(Math.max(val, 0), 0xff);
        const fill = (/** @type {string} */ str) => ('00' + str).slice(-2);

        const num = parseInt(color.substr(1), 16);
        const red = clamp((num >> 16) + amount);
        const green = clamp(((num >> 8) & 0x00ff) + amount);
        const blue = clamp((num & 0x0000ff) + amount);
        return '#' + fill(red.toString(16)) + fill(green.toString(16)) + fill(blue.toString(16));
    }

    return ColorPickerFunction((color) => {
        createAction(modeling, element, {
            fill: LightenDarkenColor(color, 150),
            stroke: color,
            label: 'picked-color',
        })();
    });
}
